/* eslint-disable jsx-a11y/anchor-is-valid */
import { ChevronDown, ChevronUp } from "lucide-react";
import { Component } from "react";

export default class BreadcrumbDropdownToggle extends Component {
  constructor(props: any, context: any) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e: any) {
    e.preventDefault();

    this.props.onClick(e);
  }

  // repair-and-maintenance-mistakes-made-in-winters

  render() {
    const { open } = this.props;
    return (
      <a href="" className="breadcrumb-dropdown-toggle" onClick={this.handleClick}>
        {this.props.children}
        {!open ? <ChevronDown size={18} style={{ marginLeft: 7 }} /> : <ChevronUp size={18} style={{ marginLeft: 7 }} />}
      </a>
    );
  }
}
